/** `meetings` namespace — Swedish (source of truth). */
const meetings = {
  calendar: {
    loading: 'Laddar kalender...',
    today: 'Idag',
    previous: 'Föregående',
    next: 'Nästa',
    week: 'Vecka',
    month: 'Månad',
    activity: 'Aktivitet',
    inviteHub: 'Bjud in HUB',
    more_one: '+{{count}} till',
    more_other: '+{{count}} till',
    activitiesAt_one: '{{count}} aktivitet kl {{hour}}',
    activitiesAt_other: '{{count}} aktiviteter kl {{hour}}',
  },
  hub: {
    start: 'Starta möte',
    starting: 'Startar möte…',
    startTitle: 'Starta möte nu',
    startDescription:
      'Välj språket som talas i mötet. HUB transkriberar och skriver anteckningarna på det språket.',
    live: 'Pågår',
    liveBadge: '● Pågår',
    join: 'Gå med i mötet',
    notConfigured: 'Videomöten är inte konfigurerade i den här miljön.',
    startFailed: 'Kunde inte starta mötet. Försök igen.',
    outOfCredits: 'Krediterna är slut. En administratör kan höja gränsen.',
    invitees: 'Deltagare',
    noInvitees: 'Inga inbjudna',
    editNotice: 'Inbjudna får ingen ny kalenderinbjudan när tiden ändras.',
  },
  create: {
    title: 'Nytt möte',
    subtitle: '{{range}}',
    name: 'Titel',
    namePlaceholder: 'Möte',
    defaultTitle: 'Möte',
    start: 'Start',
    end: 'Slut',
    invitees: 'Bjud in',
    inviteesHint: 'Du är alltid med.',
    language: 'Språk i mötet',
    languageSv: 'Svenska',
    languageEn: 'Engelska',
    hubMeeting: 'HUB-videomöte',
    hubMeetingHint: 'Video, live-transkribering och mötesanteckningar i HUB.',
    externalUrl: 'Möteslänk (valfritt)',
    externalUrlPlaceholder: 'https://meet.google.com/...',
    cancel: 'Avbryt',
    submit: 'Skapa möte',
    submitting: 'Skapar…',
    error: 'Kunde inte skapa mötet. Försök igen.',
    inviteFailures: 'Inbjudan kunde inte skickas till: {{names}}',
  },
  eventType: {
    meeting: 'Möte',
    chat: 'Chatt',
    document: 'Dokument',
    whiteboard: 'Whiteboard',
  },
  createForm: {
    title: 'Titel',
    titlePlaceholder: 'Mötestitel...',
    start: 'Start',
    end: 'Slut',
    description: 'Beskrivning',
    descriptionPlaceholder: 'Valfritt...',
    create: 'Skapa',
    close: 'Stäng',
  },
  quickInvite: {
    title: 'Bjud in HUB AI till möte',
    hint: 'Det kan ta upp till 2 minuter innan HUB AI ansluter till mötet.',
    meetingUrl: 'Möteslänk',
    urlPlaceholder: 'Klistra in Google Meet eller Teams-länk...',
    invalidUrl: 'Ange en giltig Google Meet- eller Teams-länk',
    googleMeet: '🟢 Google Meet',
    teams: '🔵 Microsoft Teams',
    alreadyActive: 'HUB AI är redan med i detta möte',
    joining: 'HUB AI ansluter till mötet...',
    error: 'Något gick fel. Försök igen.',
    cancel: 'Avbryt',
    connecting: 'Ansluter...',
    invite: 'Bjud in',
  },
  detail: {
    notFound: 'Mötet hittades inte.',
    syncing: 'Synkar möte...',
    back: 'Tillbaka till kalendern',
    edit: 'Redigera',
    delete: 'Ta bort möte',
    cancelled: 'Mötet har ställts in.',
    title: 'Titel',
    start: 'Start',
    end: 'Slut',
    meetingUrl: 'Möteslänk',
    meetingUrlPlaceholder: 'https://meet.google.com/...',
    description: 'Beskrivning',
    descriptionPlaceholder: 'Lägg till en beskrivning...',
    save: 'Spara',
    cancel: 'Avbryt',
    noDescription: 'Ingen beskrivning.',
  },
  notes: {
    title: 'Mötesanteckningar',
    generating: 'Genererar...',
    generate: 'Generera',
    regenerate: 'Generera om',
    open: 'Öppna mötesanteckningar',
    empty: 'Inga mötesanteckningar har genererats ännu.',
    noTranscript: 'Inget transkript tillgängligt för detta möte.',
    error: 'Kunde inte generera mötesanteckningar.',
  },
  /** attendee.dev bot states — the raw value is shown for anything unknown. */
  status: {
    scheduled: 'Schemalagd',
    staged: 'Förberedd',
    ready: 'Redo',
    joining: 'Ansluter',
    waiting_room: 'I väntrummet',
    joined_not_recording: 'Ansluten – spelar inte in',
    joined_recording: 'Spelar in',
    joined_recording_paused: 'Inspelning pausad',
    leaving: 'Lämnar',
    post_processing: 'Bearbetar inspelning',
    ended: 'Avslutat',
    fatal_error: 'Fel',
    cancelled: 'Inställt',
    data_deleted: 'Data raderad',
    unknown: 'Okänd',
  },
}

export default meetings
